import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken'

import {
    GET_ACCESSORY,
    GET_ALL_ACCESSORIES,
    GET_ACCESSORY_REQUEST,
    CREATE_ACCESSORY,
    UPDATE_ACCESSORY,
    DELETE_ACCESSORY,
    CLEAR_ACCESSORY
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all Accessories
export const getAccessories = () => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_ACCESSORY_REQUEST,
        payload: true
    });
    
    try {
        const res =  await axios.get(`${API_URL}/accessory/all`);

        if(res.data.success){            
            dispatch({
                type : GET_ALL_ACCESSORIES,
                payload: res.data.accessories
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch Accessories', 'danger'));
    }
}

// Get a single Accessory
export const getAccessory = id => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_ACCESSORY_REQUEST,
        payload: true
    });
    try {
        const res =  await axios.get(`${API_URL}/accessory/${id}`);
  
        if(res.data.success){  
            dispatch({
                type : GET_ACCESSORY,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched Accessory details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get Accessory details', 'danger'));
    }
};

// Add a new Accessory
export const addAccessory = formData => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
  
    try {
        const res =  await axios.post(`${API_URL}/accessory/`, formData, config);
        if(res.data.success){            
            dispatch({
                type: CREATE_ACCESSORY,
                payload: res.data
            });
            // Also set the current accessory for navigation
            dispatch({
                type: GET_ACCESSORY,
                payload: res.data
            });
            dispatch(getAccessories());
            dispatch(setAlert('Successfully added accessory', 'success'));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }      
    } catch (err) {
        dispatch( setAlert('Error: Failed to add accessory', 'danger') );
    }
};

// Update an Accessory
export const updateAccessory = (id, formData) => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };  
    try {
        const res =  await axios.put(`${API_URL}/accessory/${id}`, formData, config);
        if(res.data.success){ 
            dispatch({
                type: UPDATE_ACCESSORY,
                payload: res.data
            });
            dispatch(setAlert('Accessory Updated', 'success'));
            dispatch(getAccessories());
            dispatch(getAccessory(id));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }      
    } catch (err) {
        dispatch( setAlert('Error: Failed to update accessory', 'danger') );
    }
};

// Upload image for accessory
export const uploadAccessoryImage = (id, file) => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    
    try {
        const formData = new FormData();
        formData.append('file', file);
        
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        
        const res = await axios.post(`${API_URL}/accessory/${id}/upload`, formData, config);
        
        if(res.data.success) {
            dispatch(setAlert('Image uploaded successfully', 'success'));
            dispatch({
                type: UPDATE_ACCESSORY,
                payload: res.data
            });
        } else {
            dispatch(setAlert(res.data.error || 'Upload failed', 'danger'));
            throw new Error(res.data.error || 'Upload failed');
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to upload image', 'danger'));
        throw err;
    }
};

// Delete accessory image
export const deleteAccessoryImage = (id, imageName) => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        // Send the image name in the request body
        const res = await axios.post(`${API_URL}/accessory/${id}/delete`, { image: imageName }, config);
        
        if(res.data.success) {
            dispatch(setAlert('Image deleted successfully', 'success'));
            dispatch({
                type: UPDATE_ACCESSORY,
                payload: res.data
            });
        } else {
            dispatch(setAlert(res.data.error || 'Delete failed', 'danger'));
            throw new Error(res.data.error || 'Delete failed');
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete image', 'danger'));
        throw err;
    }
};

// Delete Accessory
export const deleteAccessory = (accessoryId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.delete(`${API_URL}/accessory/${accessoryId}`, config);
        
        if (res.data.success) {
            dispatch({
                type: DELETE_ACCESSORY,
                payload: accessoryId
            });
            dispatch(setAlert('Accessory deleted successfully', 'success'));
            // Refresh the accessories list
            dispatch(getAccessories());
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete accessory', 'danger'));
    }
};

// Clear Accessory
export const clearAccessory = () => dispatch => {
    dispatch({
        type: CLEAR_ACCESSORY,
        payload: null
    });
}; 